// 플랫폼 세션 쿠키로 토큰을 다시 받는다 — POST <플랫폼>/v1/token {"tenant"} (credentials: 'include')
// 플랫폼은 요청 Origin 이 이 MVP 의 등록 오리진일 때만 내준다. 로그인한 적이 없으면 401 — 오류가 아니라 「로그인 안 됨」이다
import { toIssuedToken, type IssuedToken } from '../domain/login';

const TIMEOUT_MS = 10_000;

export async function refreshToken(platformUrl: string, tenant: string, now: () => number = Date.now): Promise<IssuedToken | null> {
  const res = await fetch(`${platformUrl}/v1/token`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tenant }),
    signal: AbortSignal.timeout(TIMEOUT_MS),
  });
  if (!res.ok) return null;
  const body = (await res.json()) as { token?: unknown; expires_in?: unknown } | null;
  return toIssuedToken(body?.token, body?.expires_in, now());
}
